import React from "react";
import createReactClass from "create-react-class";

const mobileDecorators = [
  {
    component: createReactClass({
      render() {
        var self = this;
        var indexes = this.getIndexes(
          self.props.slideCount,
          self.props.slidesToScroll
        );
        return (
          <ul style={self.getListStyles()}>
            {indexes.map(function (index) {
              return (
                <li style={self.getListItemStyles()} key={index}>
                  <button
                    style={self.getButtonStyles(
                      self.props.currentSlide === index
                    )}
                    onClick={self.props.goToSlide.bind(null, index)}
                  >
                    &bull;
                  </button>
                </li>
              );
            })}
          </ul>
        );
      },
      getIndexes(count, inc) {
        var arr = [];
        for (var i = 0; i < count; i += inc) {
          arr.push(i);
        }
        return arr;
      },
      getListStyles() {
        return {
          position: "relative",
          margin: 0,
          top: -10,
          padding: 0,
        };
      },
      getListItemStyles() {
        return {
          listStyleType: "none",
          display: "inline-block",
        };
      },
      getButtonStyles(active) {
        return {
          border: 0,
          background: "transparent",
          color: active ? "#252528" : "#ddd",
          cursor: "pointer",
          padding: 5,
          outline: 0,
          fontSize: 40,
        };
      },
    }),
    position: "BottomCenter",
    style: {
      position: "relative",
      bottom: "auto",
      left: "auto",
      transform: "none",
      WebkitTransform: "none",
      msTransform: "none",
      display: "flex",
      justifyContent: "center",
    },
  },
];

const mobileTestimonialDecorators = [
  {
    component: createReactClass({
      render() {
        var self = this;
        var indexes = this.getIndexes(
          self.props.slideCount,
          self.props.slidesToScroll
        );
        return (
          <ul style={self.getListStyles()}>
            {indexes.map(function (index) {
              return (
                <li style={self.getListItemStyles()} key={index}>
                  <button
                    style={self.getButtonStyles(
                      self.props.currentSlide === index
                    )}
                    onClick={self.props.goToSlide.bind(null, index)}
                  >
                    &bull;
                  </button>
                </li>
              );
            })}
          </ul>
        );
      },
      getIndexes(count, inc) {
        var arr = [];
        for (var i = 0; i < count; i += inc) {
          arr.push(i);
        }
        return arr;
      },
      getListStyles() {
        return {
          position: "relative",
          margin: 0,
          top: -40,
          padding: 0,
        };
      },
      getListItemStyles() {
        return {
          listStyleType: "none",
          display: "inline-block",
        };
      },
      getButtonStyles(active) {
        return {
          border: 0,
          background: "transparent",
          color: active ? "#ddd" : "#666",
          cursor: "pointer",
          padding: 5,
          outline: 0,
          fontSize: 40,
        };
      },
    }),
    position: "BottomCenter",
    style: {
      position: "relative",
      bottom: "auto",
      left: "auto",
      transform: "none",
      WebkitTransform: "none",
      msTransform: "none",
      display: "flex",
      justifyContent: "center",
    },
  },
];

const desktopDecorators = [
  {
    component: createReactClass({
      render() {
        return (
          <div
            style={this.getButtonStyles(
              this.props.currentSlide === 0 && !this.props.wrapAround
            )}
            onClick={this.handleClick}
          >
            <img
              width="20"
              height="35"
              src="https://cdn-s3.touchofmodern.com/partners/assets/leftarrow@2x.png"
              alt="Left Arrow"
              tabIndex="0"
            />
          </div>
        );
      },
      handleClick(e) {
        e.preventDefault();
        this.props.previousSlide();
      },
      getButtonStyles(disabled) {
        return {
          cursor: "pointer",
          position: "absolute",
          top: "-100px",
          left: "-42px",
        };
      },
    }),
    position: "CenterLeft",
  },
  {
    component: createReactClass({
      render() {
        return (
          <div
            style={this.getButtonStyles(
              this.props.currentSlide + this.props.slidesToScroll >=
                this.props.slideCount && !this.props.wrapAround
            )}
            onClick={this.handleClick}
          >
            <img
              width="20"
              height="35"
              src="https://cdn-s3.touchofmodern.com/partners/assets/rightarrow@2x.png"
              alt="Right Arrow"
              tabIndex="0"
            />
          </div>
        );
      },
      handleClick(e) {
        e.preventDefault();
        this.props.nextSlide();
      },
      getButtonStyles(disabled) {
        return {
          cursor: "pointer",
          position: "absolute",
          top: "-100px",
          left: "20px",
        };
      },
    }),
    position: "CenterRight",
  },
  {
    component: createReactClass({
      render() {
        var self = this;
        var indexes = this.getIndexes(
          self.props.slideCount,
          self.props.slidesToScroll
        );
        return (
          <ul style={self.getListStyles()}>
            {indexes.map(function (index) {
              return (
                <li style={self.getListItemStyles()} key={index}>
                  <button
                    style={self.getButtonStyles(
                      self.props.currentSlide === index
                    )}
                    onClick={self.props.goToSlide.bind(null, index)}
                  >
                    &bull;
                  </button>
                </li>
              );
            })}
          </ul>
        );
      },
      getIndexes(count, inc) {
        var arr = [];
        for (var i = 0; i < count; i += inc) {
          arr.push(i);
        }
        return arr;
      },
      getListStyles() {
        return {
          position: "relative",
          margin: 0,
          top: -40,
          padding: 0,
        };
      },
      getListItemStyles() {
        return {
          listStyleType: "none",
          display: "inline-block",
        };
      },
      getButtonStyles(active) {
        return {
          border: 0,
          background: "transparent",
          color: active ? "rgb(221, 221, 221)" : "rgb(102, 102, 102)",
          cursor: "pointer",
          padding: 5,
          fontSize: 40,
        };
      },
    }),
    position: "BottomCenter",
    style: {
      position: "relative",
      bottom: "auto",
      left: "auto",
      transform: "none",
      WebkitTransform: "none",
      msTransform: "none",
      display: "flex",
      justifyContent: "center",
    },
  },
];

export { mobileDecorators, mobileTestimonialDecorators, desktopDecorators };
